// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_root__h1Up_","text":"Tag_text__2riwJ","button":"Tag_button__1aubk"};